import SearchInput from "../inputs/searchInput";
import Breadcrumb from "../breadcrumb/breadcrumb";
import { Icons } from "../../../utils/icons";
import AdvanceSorting from "../filter/advanceSorting";
import AdvanceFilter from "../filter/advanceFilter";
import DefaultButton from "../buttons/defaultButton";

const PageTableHeader = ({
  isSearch,
  onSearchChange,
  add,
  onClickAdd = null,
  filter = null,
  onClickFilter = null,
  shorting,
  onClickShorting = null,
  import_button,
  onClickImport = null,
  export_button,
  onClickExport = null,
  onChangeFilter = null, // if still needed
  buttons,
  buttonsPanel,
  breadcrumbs,
  actions,
  hidden = false,
  sortingModule = "default",
  onSortingChange = () => null,
  isFilterDisable = false,
  isDateSorting = true,
  disableText = "",
  isOtherSortText = "",
  sortByDateText = "",
  sortByNameText = "",
  sortingButtonText = { ascending: "A-Z", descending: "Z-A" },
  dateSortingButtonText = null,
  nameSortingButtonText = null,
  otherSortingButtonText = null,
  sortingProps = null,
  filterProps = null,
  children,
}) => {
  if (hidden) return null;

  // Build final props for AdvanceSorting with backwards compatibility
  const finalSortingProps = sortingProps
    ? {
        module: sortingProps.sortingModule ?? sortingModule,
        onSortingChange: sortingProps.onSortingChange ?? onSortingChange,
        isFilterDisable: sortingProps.isFilterDisable ?? isFilterDisable,
        isDateSorting: sortingProps.isDateSorting ?? isDateSorting,
        disableText: sortingProps.disableText ?? disableText,
        isOtherSortText: sortingProps.isOtherSortText ?? isOtherSortText,
        sortByDateText: sortingProps.sortByDateText ?? sortByDateText,
        sortByNameText: sortingProps.sortByNameText ?? sortByNameText,
        sortingButtonText: sortingProps.sortingButtonText ?? sortingButtonText,
        dateSortingButtonText:
          sortingProps.dateSortingButtonText ?? dateSortingButtonText,
        nameSortingButtonText:
          sortingProps.nameSortingButtonText ?? nameSortingButtonText,
        otherSortingButtonText:
          sortingProps.otherSortingButtonText ?? otherSortingButtonText,
      }
    : {
        module: sortingModule,
        onSortingChange,
        isFilterDisable,
        isDateSorting,
        disableText,
        isOtherSortText,
        sortByDateText,
        sortByNameText,
        sortingButtonText,
        dateSortingButtonText,
        nameSortingButtonText,
        otherSortingButtonText,
      };

  const finalFilterProps = filterProps
    ? {
        ...filterProps,
        filterModule: filterProps.filterModule || "default",
      }
    : null;

  const shouldShow =
    isSearch || add || filter || shorting || import_button || export_button || buttonsPanel;
  return (
    <div className="flex flex-col w-full relative text-theme overflow-hidden">
      {breadcrumbs && <Breadcrumb items={breadcrumbs} />}

      <div
        className={`flex items-center
         ${isSearch ? "justify-between" : "justify-start"}
         ${shouldShow ? "block" : "hidden"}
          bg-gray-100 p-2 rounded-md shadow-sm`}
      >
        {add ||
        filter ||
        shorting ||
        import_button ||
        export_button ||
        buttons ? (
          <div className="flex items-center text-theme text-lg">
            <div className="flex items-center overflow-visible">
              {add && (
                <div className="flex flex-row items-center">
                  <DefaultButton
                    varient="iconButton"
                    onClick={onClickAdd}
                    tooltip="Add"
                    icon={Icons.ADD}
                    className="bg-white px-2 hover:bg-bghoverlight w-7 h-7 rounded-full flexCenter mr-2"
                  />
                </div>
              )}

              {filter && (
                <div className="flex flex-row items-center">
                  {add ? (
                    <div className="w-[1px] h-4 bg-borderColor"></div>
                  ) : (
                    ""
                  )}
                  <div className="px-2">
                    <AdvanceFilter {...finalFilterProps}>
                      {children}
                    </AdvanceFilter>
                  </div>
                </div>
              )}

              {shorting && (
                <div className="flex flex-row items-center">
                  {add || filter ? (
                    <div className="w-[1px] h-4 bg-borderColor"></div>
                  ) : (
                    ""
                  )}

                  <div className="px-2">
                    <AdvanceSorting {...finalSortingProps} />
                  </div>
                </div>
              )}

              {import_button && (
                <div className="flex flex-row items-center">
                  {add || filter || shorting ? (
                    <div className="w-[1px] h-4 bg-borderColor"></div>
                  ) : (
                    ""
                  )}
                  <DefaultButton
                    varient="iconButton"
                    onClick={onClickImport}
                    tooltip="Import"
                    icon={Icons.IMPORT}
                    className="bg-white px-2 hover:bg-bghoverlight w-7 h-7 rounded-full flexCenter mx-2"
                  />
                </div>
              )}
              {export_button && (
                <div className="flex flex-row items-center">
                  {add || filter || shorting || import_button ? (
                    <div className="w-[1px] h-4 bg-borderColor"></div>
                  ) : (
                    ""
                  )}

                  <DefaultButton
                    varient="iconButton"
                    onClick={onClickExport}
                    tooltip="Export"
                    icon={Icons.EXPORT}
                    className="bg-white px-2 hover:bg-bghoverlight w-7 h-7 rounded-full flexCenter mx-2"
                  />
                </div>
              )}
            </div>

            {buttons && (
              <div className="flex flex-row items-center">
                <div className="flex items-center gap-2 pl-2">{buttons}</div>
              </div>
            )}
          </div>
        ) : (
          ""
        )}

        {isSearch && (
          <div className="text-right flex items-center !justify-end">
            <SearchInput
              placeholder="Search here..."
              onChange={onSearchChange}
            />
          </div>
        )}

        {buttonsPanel && (
          <div className="ml-auto flex items-center gap-2">{buttonsPanel}</div>
        )}
      </div>
    </div>
  );
};

export default PageTableHeader;
